export default __webpack_public_path__ + "static/media/kelechi-onuacho.67d9ea9b.png";